module.exports = __webpack_public_path__ + "img/snowman.24e0aab2.gif";